module.exports = __webpack_public_path__ + "img/finance_hutang.21e06e48.svg";